/* eslint-disable no-duplicate-case */
import {
  ADD_REPORT_DATA,
  ADD_REPORT_TYPE_MAPPING,
  RESET_REPORT_DATA
} from '../constants/reportsConstants'

const initialState = {
  reportsData: {
    id: null,
    uploadedReportsQuestion: null,
    reportName: '',
    reportType: { id: 1, name: '' },
    templateType: { name: '', url: '' },
    tasks: [{ team: [], databox: [], filters: [], questions: [] }]
  },
  reportTypeMapping: {}
}

export default function reportsReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_REPORT_DATA:
      return {
        ...state,
        reportsData: action.payload
      }
    case RESET_REPORT_DATA:
      return initialState

    case ADD_REPORT_TYPE_MAPPING:
      return {
        ...state,
        reportTypeMapping: action.payload
      }

    default:
      return state
  }
}
